// extracted by mini-css-extract-plugin
module.exports = {"vendorLogo":"Top5Usecase_vendorLogo__1RdNn"};